import axios from 'axios';

/**
 * regenerateToken.js
 * ------------------
 * Silently refreshes idTokenBilling using the stored refreshTokenBilling.
 *
 * This is called automatically every 50 minutes from App.js to keep the
 * AWS Cognito idToken alive past its 1-hour expiry, without forcing the
 * user to log out.
 *
 * Storage:
 *   Reads  → localStorage.getItem('refreshTokenBilling')
 *   Writes → localStorage.setItem('idTokenBilling', newToken)
 *
 * Safe to call at any time — if no refresh token exists (e.g. users who
 * logged in before this fix was deployed), it logs a warning and returns
 * without throwing, so the 8-hour session window still protects them.
 */
const regenerateToken = async () => {
  const refreshToken = localStorage.getItem('refreshTokenBilling');

  if (!refreshToken) {
    console.warn('[Auth] No refreshTokenBilling found — skipping silent renewal.');
    return;
  }

  const requestBody = { refresh_token: refreshToken };

  const config = {
    method: 'POST',
    url: 'https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/oauth/token?grant_type=refresh_token',
    data: JSON.stringify(requestBody),
  };

  try {
    const response = await axios(config);
    const newIdToken = response?.data?.data?.IdToken;

    if (!newIdToken) {
      console.warn('[Auth] Refresh response did not contain a new IdToken — skipping update.');
      return;
    }

    localStorage.setItem('idTokenBilling', newIdToken);
    console.log('[Auth] idTokenBilling silently refreshed at', new Date().toLocaleTimeString());
  } catch (e) {
    // Never throw — a failed refresh should not crash the app.
    console.error('[Auth] Silent token refresh failed:', e.message);
  }
};

export default regenerateToken;
